import anime from 'animejs';
import numeral from 'numeral';

export default class Counter {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.time = 2000;
        this.el = this.root.querySelector('[data-numbers-section-item-count]');
        this.targetValue = this.el.getAttribute('data-numbers-section-item-count');
        this.isFloat = this.targetValue.includes('.');

        this.observer = null;

        return true;
    }

    init() {
        this.initCounter();
    }

    initCounter() {
        const { el, targetValue, isFloat } = this;

        anime({
            targets: el,
            innerText: [0, targetValue],
            easing: 'linear',
            round: !isFloat,
            update: function (a) {
              const value = a.animations[0].currentValue;
              const formattedNumber = (isFloat) ? numeral(value).format('0.0')
                : numeral(value).format('0,000,000');
              el.innerHTML = formattedNumber;
            },
        });
    }
}